/**
 * React Query hooks for AI agents data fetching.
 */

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { listAIAgents } from "@/services/aiAgentsService";
import { useApiReady } from "@/hooks/useApi";
import type { Agent } from "@/types/security";

/**
 * Hook to fetch a list of AI agents with security issue statistics.
 * @param days - Number of days for trend calculation (default: 30)
 */
export function useAIAgents(
  days: number = 30,
  options?: Omit<UseQueryOptions<Agent[], Error, Agent[], any[]>, "queryKey" | "queryFn">
) {
  const isApiReady = useApiReady();

  return useQuery({
    queryKey: ["ai-agents", days],
    queryFn: () => listAIAgents(days),
    staleTime: 60000, // 1 minute
    enabled: isApiReady,
    ...options,
  });
}
